export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "product__allSoldOut--message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All sizes of this item are rented"])},
        "product__skuSoldOut--message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["Size ", _interpolate(_list(0)), " is currently unavailable"])}
      }
    }
  })
}
